import React from 'react';
import './ModalConfirmar.css';

function ModalConfirmar({ isOpen, titulo, mensaje, onConfirmar, onCancelar, textConfirmar = 'Eliminar', textCancelar = 'Cancelar', variante = 'peligro' }) {
    if (!isOpen) return null;

    return (
        <div className="modal-confirmar-overlay" onClick={onCancelar}>
            <div className="modal-confirmar-box" onClick={e => e.stopPropagation()}>
                {titulo && <p className="modal-confirmar-titulo">{titulo}</p>}
                {mensaje && <p className="modal-confirmar-mensaje">{mensaje}</p>}
                <div className="modal-confirmar-acciones">
                    <button className="modal-confirmar-btn-cancelar" onClick={onCancelar}>
                        {textCancelar}
                    </button>
                    <button className={`modal-confirmar-btn-confirmar ${variante}`} onClick={onConfirmar}>
                        {textConfirmar}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ModalConfirmar;
